// wwwroot/js/build/devextreme-vue-config.js

// Use CommonJS requires so webpack 5 in CJS mode has zero ambiguity
const DxSelectBox = require('devextreme-vue/select-box').default;
const { DxDateBox } = require('devextreme-vue/date-box');
const DxDataGrid = require('devextreme-vue/data-grid').default;
const DxFileUploader = require('devextreme-vue/file-uploader').default;
const DxDropDownBox = require('devextreme-vue/drop-down-box').default;
const DxValidationSummary = require('devextreme-vue/validation-summary').default;

const {
    DxValidator,
    DxRequiredRule,
    DxCompareRule,
    DxEmailRule,
    DxPatternRule,
    DxStringLengthRule,
    DxRangeRule,
    DxAsyncRule
} = require('devextreme-vue/validator');

// Build a function that takes a Vue app and registers all components on it
function registerDxComponents(app) {
    app.component('dx-validator', DxValidator);
    app.component('dx-required-rule', DxRequiredRule);
    app.component('dx-compare-rule', DxCompareRule);
    app.component('dx-email-rule', DxEmailRule);
    app.component('dx-pattern-rule', DxPatternRule);
    app.component('dx-string-length-rule', DxStringLengthRule);
    app.component('dx-range-rule', DxRangeRule);
    app.component('dx-async-rule', DxAsyncRule);

    app.component('dx-validation-summary', DxValidationSummary);

    app.component('dx-select-box', DxSelectBox);
    app.component('dx-date-box', DxDateBox);
    app.component('dx-data-grid', DxDataGrid);
    app.component('dx-file-uploader', DxFileUploader);
    app.component('dx-dropdown-box', DxDropDownBox);
}

// Export for webpack (ES export syntax is fine)
export { registerDxComponents };

// Expose it on window so your Razor inline script can call it
if (typeof window !== 'undefined') {
    window.DevextremeVueConfig = {
        registerDxComponents
    };
}
